import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

/*
 * Bara latin-delmängden.
 *
 * Standardimporten drar in samtliga teckenuppsättningar – kyrilliska,
 * grekiska, hebreiska, vietnamesiska – vilket blev 40 @font-face-regler och
 * 430 kB typsnitt som service workern hämtade utan att någonsin använda dem.
 * Appen är enbart svensk, och latin täcker å, ä och ö.
 *
 * Vinsten är större än filerna: reglerna bär långa unicode-range-listor som
 * komprimerar uselt, så CSS:en på kritisk väg gick från 26 till 8,7 kB gzip.
 */
import '@fontsource/montserrat/latin-700.css'
import '@fontsource/montserrat/latin-800.css'
import '@fontsource/open-sans/latin-400.css'
import '@fontsource/open-sans/latin-600.css'
import '@fontsource/open-sans/latin-700.css'
import './index.css'

import { App } from './App'
import { AuthProvider } from './lib/auth'
import { ThemeProvider } from './lib/theme'
import { ToastProvider } from './components/Toast'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import { HelpButton } from './components/HelpButton'
import { UpdatePrompt } from './components/UpdatePrompt'

const container = document.getElementById('root')
if (!container) throw new Error('Hittade inget #root-element att montera appen i')

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <BrowserRouter>
            {/*
             * Felgränsen ligger innanför AuthProvider så att kraschskärmen
             * kan säga vem som drabbades när rapporten skickas, och innanför
             * routern så att den vet vilken sida det small på. Skulle någon
             * av dem själva krascha finns ingen skärm att visa – men då är
             * appen ändå så trasig att en snygg ruta inte hjälper.
             */}
            <AppErrorBoundary>
              <App />
              <HelpButton />
            </AppErrorBoundary>
            <UpdatePrompt />
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
)
